import { render, staticRenderFns } from "./OrganizationModal.vue?vue&type=template&id=6c10537a"
import script from "./OrganizationModal.vue?vue&type=script&lang=js"
export * from "./OrganizationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c10537a')) {
      api.createRecord('6c10537a', component.options)
    } else {
      api.reload('6c10537a', component.options)
    }
    module.hot.accept("./OrganizationModal.vue?vue&type=template&id=6c10537a", function () {
      api.rerender('6c10537a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganizationModal.vue"
export default component.exports